export enum storageKeys {
  supabaseData = 'persist-session',
}
